<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.antecedents', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ mAntecedent.type }}
                        </h3>
                    </div>

                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>

<!--                                <b-col col sm="12">-->

<!--                                    <div class="list-group-item">-->
<!--                                        {{ $tc('message.patients', 1) }}:-->

<!--                                        <span class="font-weight-bold">-->
<!--                                {{ info }}-->
<!--                            </span>-->
<!--                                    </div>-->

<!--                                </b-col>-->

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $tc('message.types', 1) }}:

                                        <span class="font-weight-bold">
                                {{ mAntecedent.type }}
                            </span>
                                    </div>

                                </b-col>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $tc('message.startDate') }}:

                                        <span class="font-weight-bold">
                                {{ formated(mAntecedent.date) }}
                            </span>
                                    </div>

                                </b-col>

                                <b-col col sm="12">

                                    <div class="list-group-item">
                                        {{ $t('message.description') }}:

                                        <div class="font-weight-bold">
                                            {{ mAntecedent.description }}
                                        </div>
                                    </div>

                                </b-col>
                            </b-row>
                        </div>
                    </b-container>

                    <b-container>

                    <b-row class="justify-content-center">
                        <div class="card-footer text-right" v-if="mAntecedent.isAuthor || hasMedecinControleRole || hasAdminRole || hasAssistante">
                            <b-button variant="primary" @click="updateAntecedent">
                                {{ $t('message.edit') }}
                            </b-button>

                            <b-button v-b-modal.delete-modal variant="danger">
                                {{ $t('message.delete') }}
                            </b-button>
                        </div>
                    </b-row>

                    </b-container>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.antecedents', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mAntecedent.type }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteAntecedent">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    export default {
        name: "Antecedent",

        computed: {
            ...mapGetters(["antecedent", "hasAdminRole", "hasMedecinControleRole", "hasPraticienRole", "hasAssistante"]),

            mAntecedent: function() {
                return this.antecedent;
            },

            info:function(){
                if (typeof this.mAntecedent.user == 'object'){
                    let user = this.mAntecedent.user;
                    let fullName =  user.prenom? user.prenom  : '' + (user.nom).toUpperCase();
                    return fullName+ " ( "+ this.mAntecedent.dossier.numero_dossier + " ) ";
                }
                return  "";
            }
        },

        data() {
            return {
                antecedent_id: this.$route.params.antecedent
            }
        },

        methods: {
            getAntecedent() {
                let args = {
                    antecedent: this.antecedent_id
                };

                this.$store.dispatch("getAntecedent", { args });
            },
            formated(date){
                return moment(date).isValid() ? moment(date).format('DD-MM-YYYY') : "";
            },
            updateAntecedent() {
                this.$router.push({ name: 'edit-antecedent', params: { antecedent: this.antecedent_id } });
            },

            deleteAntecedent() {
                let self = this;
                let args = {
                    antecedent: this.antecedent_id
                };

                let successMessage = this.$i18n.t('message.antecedentDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteAntecedent', { args, index: self.antecedent_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            }
        },

        mounted() {
            this.getAntecedent();
        }
    }
</script>

<style scoped>

</style>